export default {
  all: {
    en: 'All',
  },
  bodyMoisturizers: {
    en: 'Body Moisturizers',
  },
  handCreams: {
    en: 'Hand Cream',
  },
  shower: {
    en: 'Shower',
  },
  bodyWash: {
    en: 'Body Wash',
  },
  bodyScrubs: {
    en: 'Body Scrub',
  },
}
